function Sidebar({ children, title }) {
  return (
    <aside className="sidebar-container   ">
      <h3 className="board-title">{title}</h3>
      <nav>
        <ul className="navigation-list">{children}</ul>
      </nav>
    </aside>
  );
}

export default Sidebar;
